// import React from "react";
// import "../css/LoanClosureReport.css";
// import timelineImage from "../assets/h2.png"; // A creative loan/clock/timeline image

// const LoanClosureReport = () => {
//   return (
//     <div className="LoanClosureReport-wrapper">
//       <div className="LoanClosureReport-leftPanel">
//         <h1 className="LoanClosureReport-title">Loan Closure Report</h1>
//         <p className="LoanClosureReport-message">
//           📊 This page is under development.
//         </p>
//         <p className="LoanClosureReport-message">
//           Soon, you will be able to monitor all closed loans, track pre-closures, 
//           see outstanding balances, and visualize closure timelines.
//         </p>
//         <p className="LoanClosureReport-message">
//           Powerful features like progress tracking, overdue alerts, and closure statistics are on the way!
//         </p>

//         <div className="LoanClosureReport-progress">
//           <div className="progress-bar complete">
//             <span>Closed Loans</span>
//           </div>
//           <div className="progress-bar pending">
//             <span>Pending Closure</span>
//           </div>
//           <div className="progress-bar alert">
//             <span>Overdue</span>
//           </div>
//         </div>

//         <div className="LoanClosureReport-flashingText">
//           🔔 LOAN CLOSURE DASHBOARD COMING SOON
//         </div>
//       </div>

//       <div className="LoanClosureReport-rightPanel">
//         <img
//           src={timelineImage}
//           alt="Loan Timeline"
//           className="LoanClosureReport-image"
//         />
//       </div>
//     </div>
//   );
// };

// export default LoanClosureReport;




// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchLoanReports, deleteLoan } from "../redux/slices/loanReportSlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "../css/LoanReport.css";
// import axios from "axios";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

// const API_URL = "https://narrowitsolution.in/api/"; 

// const LoanClosureReport = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { loans, loading, error } = useSelector((state) => state.loanReport);

//   const [filterData, setFilterData] = useState({
//     fromDate: "",
//     toDate: "",
//     loanAccountNumber: "",
//     userId: "",
//     userName: "",
//     loanStatus: "",
//   });

//   const [filteredLoans, setFilteredLoans] = useState([]);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   useEffect(() => {
//     dispatch(fetchLoanReports());
//   }, [dispatch]);

//   useEffect(() => {
//     setFilteredLoans(loans);
//     setCurrentPage(1);
//   }, [loans]);

//   useEffect(() => {
//     if (error) {
//       toast.error(`Error: ${error}`);
//     }
//   }, [error]);

//   const handleChange = (e) => {
//     setFilterData({ ...filterData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const filtered = loans.filter((loan) => {
//       const {
//         fromDate,
//         toDate,
//         loanAccountNumber,
//         userId,
//         userName,
//         loanStatus,
//       } = filterData;
//       const appliedDate = new Date(loan.appliedDate);

//       return (
//         (!fromDate || appliedDate >= new Date(fromDate)) &&
//         (!toDate || appliedDate <= new Date(toDate)) &&
//         (!loanAccountNumber ||
//           loan.loanAccountNumber
//             ?.toLowerCase()
//             .includes(loanAccountNumber.toLowerCase())) &&
//         (!userId || loan.userId?.toString() === userId) &&
//         (!userName ||
//           loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
//         (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
//       );
//     });

//     setFilteredLoans(filtered);
//     setCurrentPage(1);
//   };

//   const handleApproveLoan = async (loan) => {
//     console.log("➡️ Approve Loan button clicked");
//     console.log("Loan ID:", loan.id);
//     console.log("Current Loan Status:", loan.status);

//     if (loan.status === "Approved" || loan.status === "disbursed") {
//       console.info(`⚠️ Loan is already ${loan.status}, skipping approval.`);
//       toast.info(`Loan is already ${loan.status}`);
//       return;
//     }

//     try {
//       console.log("🔧 Sending approve loan API request...");
//       const response = await axios.post(
//         `${API_URL}approveLoan-personal/${loan.id}/approve`,
//         { approvalRemark: "Verified documents" }
//       );

//       console.log("✅ API Response:", response.data);
//       toast.success(response.data.message);

//       dispatch(fetchLoanReports());
//     } catch (error) {
//       console.error("🚨 Loan Approval Error:", error);
//       toast.error(error.response?.data?.message || "Failed to approve loan");
//     }
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="LoanReport-container">
//       {/* Filter Section */}
//       <section className="LoanReport-filterSection">
//         <h2 className="LoanReport-title">Loan Report Filter</h2>
//         <p className="LoanReport-subtitle">
//           Use filter to see more precise report
//         </p>
//         <form className="LoanReport-form" onSubmit={handleSubmit}>
//           <div className="LoanReport-grid">
//             {/* <div className="LoanReport-formGroup">
//               <label>From Date</label>
//               <input type="date" name="fromDate" onChange={handleChange} />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>To Date</label>
//               <input type="date" name="toDate" onChange={handleChange} />
//             </div> */}
//             <div className="LoanReport-formGroup">
//               <label>Loan Account Number</label>
//               <input
//                 type="text"
//                 name="loanAccountNumber"
//                 placeholder="Loan account number"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User ID</label>
//               <input
//                 type="text"
//                 name="userId"
//                 placeholder="Applicant user id"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 placeholder="Applicant user name"
//                 onChange={handleChange}
//               />
//             </div>
//             {/* <div className="LoanReport-formGroup">
//               <label>Choose Loan Status</label>
//               <select name="loanStatus" onChange={handleChange}>
//                 <option value="">Select loan status</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Rejected">Rejected</option>
//                 <option value="Closed">Closed</option>
//               </select>
//             </div> */}
//           </div>
//           <button type="submit" className="LoanReport-submitBtn">
//             Submit
//           </button>
//         </form>
//       </section>

//       {/* Loan Details Section */}
//       <section className="LoanReport-detailsSection">
//         <div className="LoanReport-tableHeader">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//           <input
//             type="text"
//             placeholder="Search..."
//             className="LoanReport-searchInput"
//           />
//         </div>

//         <div className="LoanReport-tableContainer">
//           <table className="LoanReport-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>Loan Status</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>View EMI</th>
//                 <th>Loan Card</th>
//                 <th>Loan Status</th>
//                 <th>Approved Action</th>
//                 <th>Disbursement Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="22">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="22">Error: {error}</td>
//                 </tr>
//               ) : currentLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="22">No data available</td>
//                 </tr>
//               ) : (
//                 currentLoans.map((loan, index) => (
//                   <tr key={loan.id}>
//                     <td>{startIndex + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.userName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{formatDate(loan.loanAppliedDate)}</td>
//                     <td>{formatDate(loan.firstEmiDate)}</td>
//                     <td>{formatDate(loan.disbursalDate)}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanEmiAmount || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td>
//                     <td>{loan.status || "N/A"}</td>

//                     {/* Approved Action */}
//                     <td>
//                       {loan.status === "PENDING" && (
//                         <button
//                           onClick={() => {
//                             const confirmApprove = window.confirm(
//                               "Do you want to approve this loan?"
//                             );
//                             if (confirmApprove) handleApproveLoan(loan);
//                           }}
//                         >
//                           Approve Loan
//                         </button>
//                       )}
//                       {(loan.status === "Approved" || loan.status === "disbursed") && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>

//                     {/* Disbursement Action */}
//                     <td>
//                       {loan.status === "Approved" && (
//                         <button
//                           onClick={() =>
//                             navigate(`/LoanDisbursement/${loan.id}`, {
//                               state: { selectedLoan: loan },
//                             })
//                           }
//                           style={{
//                             marginLeft: "6px",
//                             background: "#1f8b94ff",
//                             color: "#fff",
//                             padding: "5px 10px",
//                             border: "none",
//                             borderRadius: "4px",
//                           }}
//                         >
//                           Disburse Loan
//                         </button>
//                       )}
//                       {loan.status === "disbursed" && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="LoanReport-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </section>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanClosureReport;




import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchLoanReports } from "../redux/slices/loanReportSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/LoanReport.css";
import axios from "axios";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];
const API_URL = "https://narrowitsolution.in/api/";

const LoanClosureReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loans = [], loading, error } = useSelector(
    (state) => state.loanReport
  );

  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    loanAccountNumber: "",
    userId: "",
    userName: "",
  });

  const [filteredLoans, setFilteredLoans] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLoan,setSelectedLoan]=useState();

  // Fetch all loans
  useEffect(() => {
    dispatch(fetchLoanReports());
  }, [dispatch]);

  
  // Apply CLOSED and REQUESTED status filter whenever loans change
  useEffect(() => {
    const filtered = loans.filter(
      (loan) =>
        ["closed", "requested"].includes(loan?.status?.toLowerCase())
    );
    setFilteredLoans(filtered);
    setCurrentPage(1);
  }, [loans]);


  // Show error toast
  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error}`);
    }
  }, [error]);

  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

   const [formData, setFormData] = useState({
        loancloserremark: "",
      });

  // Apply additional filters (still only within CLOSED loans)
  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      fromDate,
      toDate,
      loanAccountNumber,
      userId,
      userName,
    } = filterData;

    const filtered = loans
      .filter((loan) => loan?.status?.toLowerCase() === "closed")
      .filter((loan) => {
        const appliedDate = loan?.loanAppliedDate
          ? new Date(loan.loanAppliedDate)
          : null;

        return (
          (!fromDate || (appliedDate && appliedDate >= new Date(fromDate))) &&
          (!toDate || (appliedDate && appliedDate <= new Date(toDate))) &&
          (!loanAccountNumber ||
            loan.loanAccountNumber
              ?.toLowerCase()
              .includes(loanAccountNumber.toLowerCase())) &&
          (!userId || loan.userId?.toString() === userId) &&
          (!userName ||
            loan.userName
              ?.toLowerCase()
              .includes(userName.toLowerCase()))
        );
      });

    setFilteredLoans(filtered);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
  };


 const verifyLoan = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.post(
      `https://narrowitsolution.in/api/loan/close/${selectedLoan?.id}`,
      {
        closureRemark: formData.loancloserremark,
        closureDate: new Date().toISOString().split("T")[0], // YYYY-MM-DD
      }
    );

    toast.success("Loan closure verified successfully!");
    setModalOpen(false);
    return response.data;
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Something went wrong while verifying loan closure request.";

    toast.error(msg);
    console.error("Error in verifying loan closure request.", msg);
    return null;
  }
};


  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentLoans = filteredLoans.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="LoanReport-container">
      {/* Filter Section */}
      <section className="LoanReport-filterSection">
        <h2 className="LoanReport-title">Closed Loan Report Filter</h2>
        <p className="LoanReport-subtitle">
          Use filter to see more precise closed loan reports
        </p>
        <form className="LoanReport-form" onSubmit={handleSubmit}>
          <div className="LoanReport-grid">
            <div className="LoanReport-formGroup">
              <label>Loan Account Number</label>
              <input
                type="text"
                name="loanAccountNumber"
                placeholder="Loan account number"
                onChange={handleChange}
              />
            </div>
            <div className="LoanReport-formGroup">
              <label>Applicant User ID</label>
              <input
                type="text"
                name="userId"
                placeholder="Applicant user id"
                onChange={handleChange}
              />
            </div>
            <div className="LoanReport-formGroup">
              <label>Applicant User Name</label>
              <input
                type="text"
                name="userName"
                placeholder="Applicant user name"
                onChange={handleChange}
              />
            </div>
          </div>
          <button type="submit" className="LoanReport-submitBtn">
            Submit
          </button>
        </form>
      </section>

      {/* Loan Details Section */}
      <section className="LoanReport-detailsSection">
        <div className="LoanReport-tableHeader">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
          {/* <input
            type="text"
            placeholder="Search..."
            className="LoanReport-searchInput"
            disabled
          /> */}
        </div>

        <div className="LoanReport-tableContainer">
          <table className="LoanReport-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>Loan Status</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                {/* <th>View EMI</th>
                <th>Loan Card</th> */}
                <th>Verify</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">Error: {error}</td>
                </tr>
              ) : currentLoans.length === 0 ? (
                <tr>
                  <td colSpan="17">No closed loans found</td>
                </tr>
              ) : (
                currentLoans.map((loan, index) => (
                  <tr key={loan?.id || index}>
                    <td>{startIndex + index + 1}</td>
                    <td>{loan?.loanAccountNumber || "N/A"}</td>
                    <td>{loan?.userName || "N/A"}</td>
                    <td>{loan?.loanAmount ?? "N/A"}</td>
                    <td>{loan?.loanInterest ?? "N/A"}</td>
                    <td>{loan?.loanTenure ?? "N/A"}</td>
                    <td>{loan?.loanRecoveryFrequency || "N/A"}</td>
                    <td>{formatDate(loan?.loanAppliedDate)}</td>
                    <td>{formatDate(loan?.firstEmiDate)}</td>
                    <td>{formatDate(loan?.disbursalDate)}</td>
                    <td>{loan?.status || "N/A"}</td>
                    <td>{loan?.loanEmiAmount ?? "N/A"}</td>
                    <td>{loan?.loanPayable ?? "N/A"}</td>
                    <td>{loan?.loanType || "N/A"}</td>
                    {/* <td>
                      <button
                        onClick={() =>
                          navigate(`/ViewEmiLoanData/${loan?.id}`)
                        }
                      >
                        View EMI
                      </button>
                    </td>
                    <td>
                      <button
                        onClick={() => navigate(`/LoanCardPage/${loan?.id}`)}
                      >
                        Loan Card
                      </button>
                    </td> */}
                    <td>
                      <button
                        // disabled={loan?.status?.toLowerCase() === "closed"}
                        onClick={() => {
                          setSelectedLoan(loan);
                          setModalOpen(true);
                        }}
                      >
                        Verify
                      </button>
                    </td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="LoanReport-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </section>

        {/* Modal */}
        {modalOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2 className="dialog-box-heading">
                {"Verify Loan"}
              </h2>

              <form className="dialog-box-form-section" onSubmit={verifyLoan}>
                <div className="dialog-box-input-group">
                  <label>Loan Closure Remark</label>
                   <input
                    type="text"
                    name="loancloserremark"
                    value={formData.loancloserremark}
                    onChange={handleChange1}
                  />
                </div>

                <div className="dialog-btns">
                  <button type="submit">
                    {"Verify"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LoanClosureReport;
